import { render, staticRenderFns } from "./SavedFavorites.vue?vue&type=template&id=c66b1a24&scoped=true&"
import script from "./SavedFavorites.vue?vue&type=script&lang=js&"
export * from "./SavedFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66b1a24",
  null
  
)

export default component.exports